module.exports = __webpack_public_path__ + "static/img/top-right.38eab1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/design/top-right.png
// module id = i5gI
// module chunks = 0